import { createApp } from 'vue';
import TariffNotificationModals from './TariffNotificationModals.vue';
import Toast, { POSITION } from 'vue-toastification';

const app = createApp(TariffNotificationModals);
app.use(Toast, {
    bodyClassName: 'notification__body',
    toastClassName: 'notification',
    position: POSITION.BOTTOM_RIGHT,
});
app.mount('#tariffNotificationModals');
